import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance2,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  SUBSCRIPTIONV2DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchSubscriptionV2Details = async gid => axiosAuthInstance2.get(`${API_END_POINTS.SUBSCRIPTION}/${gid}`);

const fetchSubscriptionV2Payments = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const queryParam = `&subscription2.gid.EQ=${payload.gid}`;
  const sorting = '&sortBy=paymentSession.paymentDate&direction=DESC';
  return axiosAuthInstance2.get(`/subscription-payment-session/payment-sessions/${query}${queryParam}${sorting}`);
};

const fetchSubscriptionV2Timeline = async (payload) => {
  const query = `?page=${payload.currentPage}&size=${payload.pageSize}`;
  const queryParam = `&subscription2Gid.EQ=${payload.gid}`;
  const sorting = '&sortBy=timestamp&direction=DESC';
  return axiosAuthInstance2.get(`/subscription/timeline/${query}${queryParam}${sorting}`);
};

export function* getSubscriptionV2Details(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchSubscriptionV2Details, action.payload);
    yield put({ type: SUBSCRIPTIONV2DETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTIONV2DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getSubscriptionV2Payments(action) {
  try {
    const { data: { entity } } = yield call(fetchSubscriptionV2Payments, action.payload);
    yield put({ type: SUBSCRIPTIONV2DETAILS.PAYMENTS_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTIONV2DETAILS.FAILED, payload: e.response.data });
  }
}

export function* getSubscriptionV2Timeline(action) {
  try {
    const { data: { entity } } = yield call(fetchSubscriptionV2Timeline, action.payload);
    yield put({ type: SUBSCRIPTIONV2DETAILS.TIMELINE_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTIONV2DETAILS.FAILED, payload: e.response.data });
  }
}
